import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getFeatureWaitlist } from 'api/HealthcareProgram';

import { FEATURE_WAITLIST_QUERY_KEY } from 'lib/constants/healthcareProgram/eligibilitySetup';

// Feature keys the current practice has already joined the wait list for.
// Lets the UI persist the "You're on the waitlist" state across refreshes.
export const useFeatureWaitlist = ({ enabled = true } = {}) => {
  const navigate = useNavigate();

  return useQuery(
    [FEATURE_WAITLIST_QUERY_KEY],
    async () => {
      const res = await getFeatureWaitlist(navigate, {});
      return res?.feature_keys ?? [];
    },
    {
      enabled,
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false
    }
  );
};
